module.exports = __webpack_public_path__ + "static/media/tournaments-future-menu-icon.f4fe35a8.svg";